<template>
  <el-tooltip
    class="item"
    effect="dark"
    :content="
      $t('SEARCH_BY', {
        type: $t('search_in_license'),
      })
    "
    placement="top"
  >
    <el-form-item
      :label="$t(!label ? 'VEHICLE_TITLE' : label)"
      :prop="prop"
      class="information"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
    >
      <el-select
        :disabled="disabled"
        v-model="selectValue"
        @change="selectedValue"
        @clear="clear"
        @blur="$emit('blur')"
        @visible-change="handleVisibleChange"
        :filter-method="filterMethod"
        filterable
        clearable
        :placeholder="$t('SELECT_PLACEHOLDER')"
        :multiple="multiple"
        :collapse-tags="collapseTags"
      >
        <el-option
          v-for="item in options"
          :key="item.id + Math.random()"
          :label="
            item.license_plate.substring(7, 9) +
            '|' +
            item.license_plate.substring(4, 7) +
            (alphaList.find(
              (i) => i.code == item.license_plate.substring(2, 4)
            ) != undefined
              ? alphaList.find(
                  (i) => i.code == item.license_plate.substring(2, 4)
                ).char
              : '') +
            item.license_plate.substring(0, 2) +
            ' - ' +
            item.vehicle.fa_title
          "
          :value="item.id"
        >
          <LicenseOption
            :license_plate="item.license_plate"
            :vehicle="item.vehicle"
            :chars="alphaList"
          />
        </el-option>
      </el-select>
    </el-form-item>
  </el-tooltip>
</template>

<script>
import { licenseChars } from '@/api/global'
import { carsListSummary } from '@/api/cars'
import LicenseOption from '@/components/cars/LicenseOption.vue'

export default {
  props: [
    'prop',
    'model',
    'disabled',
    'multiple',
    'collapseTags',
    'filterable',
    'label',
    'metricsFilter',
  ],
  data() {
    return {
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      selectValue: this.model,
      options: [],
      loading: true,
    }
  },
  components: {
    LicenseOption,
  },
  methods: {
    selectedValue() {
      this.$emit('update', this.selectValue)
    },

    handleVisibleChange(visible) {
      // When dropdown closes (visible becomes false), emit blur event
      if (!visible) {
        this.$emit('blur')
      }
    },
    filterMethod: function (search) {
      this.options = []
      this.loading = true

      const currentRequest = new Promise(async (resolve, reject) => {
        try {
          if (this.currentRequest) {
            await this.currentRequest
          }

          const res = await carsListSummary.api(
            search ? this.toEnglish(search) : '',
            this.metricsFilter
          )

          if (res) {
            this.options = res
            this.loading = false
            resolve(res)
          }
        } catch (error) {
          console.error('Error:', error)
          this.loading = false
          reject(error)
        }
      })

      this.currentRequest = currentRequest

      return currentRequest
    },

    clear() {
      // Emit clear event to parent component
      this.$emit('clear')

      carsListSummary.api('', this.metricsFilter).then((res) => {
        if (res) {
          this.$emit('totalCount', res.length)
          this.options = res
          this.loading = false
        }
      })
    },

    loadVehiclesForMetric() {
      if (this.metricsFilter && !this.disabled) {
        this.loading = true
        carsListSummary.api('', this.metricsFilter).then((res) => {
          if (res) {
            this.$emit('totalCount', res.length)
            this.options = res
          }
          this.loading = false
        })
      }
    },
  },
  created() {
    licenseChars.api().then((res) => {
      this.alphaList = res
    })

    carsListSummary.api('', this.metricsFilter).then((res) => {
      if (res) {
        this.$emit('totalCount', res.length)
        this.options = res
      }
      this.loading = false
    })
  },
  watch: {
    model: {
      handler: function (val, oldVal) {
        this.selectValue = val
      },
      deep: true,
    },
    metricsFilter: {
      handler: function (newVal, oldVal) {
        if (newVal && !this.disabled) {
          this.loadVehiclesForMetric()
        } else if (!newVal) {
          this.options = []
        }
      },
      immediate: false,
    },
    disabled: {
      handler: function (newVal, oldVal) {
        if (!newVal && this.metricsFilter) {
          this.loadVehiclesForMetric()
        }
      },
    },
  },
}
</script>
